import type { TError, TMiniProgramCatalogItem } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';

const ENTITY = 'programs';

export const getMiniProgramCatalogQueryKey = () => [ENTITY, 'mini-catalog'];

/**
 * Fetches the Members Panel mini-program catalog (aggregated by members-api from
 * addon-api). The caller applies per-user ownership/visibility rules on top.
 * Short staleTime + refetch on focus so publish toggles made in the dashboard
 * show up when the user returns to an already-open members tab.
 */
export const useGetMiniProgramCatalogQuery = () => {
  return useQuery<TMiniProgramCatalogItem[], TError>({
    queryKey: getMiniProgramCatalogQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TMiniProgramCatalogItem[]>('/programs/mini-catalog');
      return res.data;
    },
    staleTime: 30 * 1000,
  });
};
